<template>
  <div id="app">
    <NavigationBar/>
    <div class="section">
    <router-view/>
    </div>
  </div>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";

export default {
  name: 'app',
  components: {
    NavigationBar,
  },
  data: () => ({
    mobileMenuActive: false,
    loading: true,
    user: {},
    auth: {},
    isAuthenticated: false,
    error: null
  }),
  computed : {
    isLoggedIn : function(){ return this.$store.getters.isAuthenticated}
  },
  methods: {
  },
  async created() {
    try {
      // If the user is returning to the app after authentication..
      if (
        this.$route.query.auth_code
      ) {
        const authCode = this.$route.query.auth_code;
        this.$store.dispatch("authenticate", authCode).finally((res) => { // eslint-disable-line no-unused-vars
          if(this.$store.getters.isAuthenticated) {
            this.$router.replace({name: "profile"});
          } else {
            this.$router.replace("/");
          }
        });
      }
    } catch (e) {
      this.error = e;
    } finally {
      // Initialize our internal authentication state
      //this.isAuthenticated = await this.isAuthenticated();
      //this.user = await this.getUser();
      this.loading = false;
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*ext-align: center;*/
  color: #2c3e50;
}

#nav {
  padding: 30px;
  text-align: center;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
